/** Arrow Drone 미니 드론 — 제품 디자인 케이스 데이터 */

export const ARROW_DRONE_SLUG = 'arrow-drone'

export const ARROW_DRONE_SHEET_IMG = '/assets/img/design/arrow-drone-sheet.png'
export const ARROW_DRONE_COLLAGE_IMG = '/assets/img/design/arrow-drone-collage.png'
export const ARROW_DRONE_LIFESTYLE_IMG = '/assets/img/design/arrow-drone-lifestyle.png'

export const arrowDronePortfolioCard = {
    slug: ARROW_DRONE_SLUG,
    title: 'Arrow Drone',
    excerpt:
        '활·화살 모티브의 미니 쿼드콥터 — 활 형태 프로펠러 가드, 활시위 음각 페이드로 아이덴티티를 표현했습니다.',
    image: ARROW_DRONE_LIFESTYLE_IMG,
    imageAlt: 'Arrow Drone 미니 드론 — 산악 라이프스타일 비행 컷',
    year: '2023',
    tags: ['미니 드론', '쿼드콥터', 'CMF'],
}

const arrowDroneShowcases = [
    {
        id: 'arrow-drone-collage',
        kicker: 'Detail',
        title: '구조 · 상부 · 프로펠러',
        tagline: 'Mini-Drones · Arrow Drone',
        image: ARROW_DRONE_COLLAGE_IMG,
        imageAlt:
            'Arrow Drone — 하단 환기·전면 LED, 상부 화이트 플레이트·헥사곤 라인, 전체 쿼드콥터 콜라주',
        description: [
            '좌측 로우 앵글에서는 하단 환기 리브·전면 블루 LED·실버 모터 샤프트·케이지형 프로펠러 가드를 확인할 수 있습니다. 블랙 섀시와 화이트 상판의 대비로 테크 가전 톤을 유지했습니다.',
            '우측 상단은 탑뷰로 화이트 상판의 각진 헥사곤 라인과 대칭 암·가드 구조를, 하단은 버드아이 뷰로 4로터 전체 실루엣과 전면 LED 방향을 담았습니다.',
        ],
        features: [
            {
                title: '활 형태 가드',
                text: '4개 프로펠러 가드를 활처럼 바깥으로 휘어 드론 본체를 보호하면서 스토리를 전달합니다.',
            },
            {
                title: '활시위 음각',
                text: '상판에 활시위를 당기는 형상을 음각·페이드로 표현해 Arrow Drone 아이덴티티를 고정했습니다.',
            },
            {
                title: '2톤 CMF',
                text: '매트 화이트 상판·블랙 암·가드·프로펠러로 미니멀·프로페셔널 인상을 맞췄습니다.',
            },
            {
                title: '환기·상태 LED',
                text: '하단 슬릿 환기와 전면 블루 LED로 방향·전원 상태를 직관적으로 읽을 수 있게 했습니다.',
            },
        ],
    },
    {
        id: 'arrow-drone-lifestyle',
        kicker: 'Lifestyle',
        title: 'Arrow Drone',
        tagline: 'Mini-Drones',
        image: ARROW_DRONE_LIFESTYLE_IMG,
        imageAlt: 'Arrow Drone — 산악 초원 배경 호버링 라이프스타일 컷',
        description: [
            '산악·초원 배경에서 호버링하는 라이프스타일 컷으로 야외 비행·촬영 사용 맥락을 제시했습니다. 배경 보케로 제품 실루엣에 시선을 집중시켰습니다.',
            '컴팩트 볼륨(176×180×38 mm)이 풍경 속에서도 한눈에 읽히도록 측면·상부 프로필이 드러나는 구도입니다.',
        ],
        features: [
            {
                title: '야외 비행 시나리오',
                text: '자연광·지형 배경으로 취미·아웃도어 포지셔닝을 강조했습니다.',
            },
            {
                title: '컴팩트 실루엣',
                text: '낮은 프로파일(38 mm)로 휴대·이동 시 부피감을 줄였습니다.',
            },
            {
                title: '4로터 안정감',
                text: '대칭 암·가드 구조가 공중에서 균형 잡힌 인상을 전달합니다.',
            },
            {
                title: '마케팅 컷',
                text: '상세·배너·SNS에 활용 가능한 히어로급 라이프스타일 렌더입니다.',
            },
        ],
    },
]

const arrowDroneProcessPhases = [
    {
        id: 'concept',
        title: '콘셉트 & 스토리',
        lede: '활과 화살을 모티브로 한 미니 드론 콘셉트입니다.',
        body: '프로펠러 가드가 활처럼 본체를 감싸 보호하고, 몸통에는 활시위를 당겨 화살을 쏘는 동작을 형상화했습니다. 음각과 페이드 처리로 Arrow Drone만의 아이덴티티를 상판에 녹였습니다.',
    },
    {
        id: 'form',
        title: '형태 & 구조',
        lede: '176×180×38(mm) 스케일의 낮고 넓은 쿼드콥터 볼륨을 설계했습니다.',
        body: '화이트 상판·블랙 암·케이지 가드·실버 모터 포인트로 기능 구역을 분리했습니다. PLASTIC 재질을 전제로 가드·상판·하부 섀시를 분할해 양산·조립을 고려했습니다.',
    },
    {
        id: 'cmf',
        title: 'CMF & 디테일',
        lede: '미니멀 2톤과 헥사곤 라인으로 테크 제품 톤을 맞췄습니다.',
        body: '상판 각진 면과 음각 라인, 하단 환기 슬릿, 전면 LED로 프리미엄·내구 이미지를 동시에 표현했습니다. 프로펠러·모터는 메탈 톤으로 대비를 주었습니다.',
    },
    {
        id: 'viz',
        title: '시각화',
        lede: 'Rhinoceros·KeyShot·Photoshop으로 시트·콜라주·라이프스타일 렌더를 제작했습니다.',
        body: '탑뷰 제품 시트, 3분할 디테일 콜라주, 산악 배경 라이프스타일 컷으로 갤러리·상세·마케팅에 맞는 산출물 세트를 구성했습니다.',
    },
]

export const arrowDroneDesignCase = {
    pageTitle: 'Arrow Drone 미니 드론',
    masthead: 'Arrow Drone',
    mastheadSub: 'Mini-Drones',
    showcaseSectionTitle: '제품 특징 · 상세',
    metaDescription:
        'Arrow Drone 미니 드론 — 활·화살 모티브 프로펠러 가드, 활시위 음각 아이덴티티, Rhino·KeyShot 제품 디자인 사례입니다.',
    meta: {
        client: 'Arrow Drone',
        year: '2023',
        scope: '제품 디자인 · Rhinoceros · KeyShot · Photoshop',
        size: '176 × 180 × 38 (mm)',
        material: 'PLASTIC',
    },
    intro: {
        lead: '활과 화살을 모티브로 한 미니 쿼드콥터 드론입니다. 4개의 프로펠러 가드가 활 형태로 본체를 보호합니다.',
        left: '드론 몸통에는 활을 당겨 화살을 쏘는 듯한 활시위 형상을 음각·페이드로 표현해 Arrow Drone의 아이덴티티로 자리 잡도록 했습니다. 화이트 상판과 블랙 암·가드의 대비로 미니멀한 테크 톤을 유지합니다.',
        right: '제품 시트로 콘셉트·스펙·탑뷰를, 디테일 콜라주로 구조·상부·전체 실루엣을, 라이프스타일 컷으로 야외 비행 맥락을 각각 전달합니다.',
    },
    hero: {
        src: ARROW_DRONE_SHEET_IMG,
        alt: 'Arrow Drone 제품 시트 — Mini-Drones, 탑뷰·스펙·3D 렌더',
    },
    productShowcases: arrowDroneShowcases,
    processPhases: arrowDroneProcessPhases,
    deliverables: [
        '활·화살 모티브 콘셉트·프로펠러 가드·상판 음각 정리',
        'Rhinoceros 3D 모델 및 KeyShot 고해상도 렌더',
        'CMF·2톤 마감·LED·환기 구조 시안',
        '제품 스펙 시트(176×180×38 mm · PLASTIC · 2023)',
        'Photoshop 프레젠테이션·디테일 콜라주·라이프스타일 컷',
    ],
    outro: [
        '스토리 모티브를 가드·상판 디테일에 녹이면 소형 드론도 브랜드 인지를 높일 수 있습니다.',
        'Arrow Drone은 보호 구조와 아이덴티티 그래픽을 동시에 다룬 미니 드론 제품 디자인 사례입니다.',
        '코담디자인은 테크·라이프스타일 제품의 형태·CMF·렌더 시각화를 지원합니다.',
    ],
}
